import FormDamages from "../../../../Components/FormDamages";
import { damageComponents, damageTypes } from "../../../../system/damages";
import { Form } from "../../../../system/useForm";

export default ({ form } : { form : Form }) => {
	return (
		<>
			<FormDamages
				name="damagesExterior"
				form={form}
				damageTypes={damageTypes.exterior}
				damageComponents={damageComponents.exterior}
			/>
		</>
	);
};
